import React from 'react';
import SingleBlog from './singleBlog/SingleBlog';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { allPostByAuthor, allPostByCategory } from '../../redux/filter/actions';

const filterByCategory = (post, filter) => {
    if (filter.category === '') {
        return post;
    } else {
        return post.category === filter.category;
    }
}
const filterByAuthor = (post, filter) => {
    if (filter.author === '') {
        return post;
    } else {
        return post.author === filter.author;
    }
}

const AllBlogs = () => {
    const dispatch = useDispatch();
    let posts = useSelector(state => state.post);
    const filter = useSelector(state => state.filter);

    posts = posts.filter(post => filterByCategory(post, filter))
        .filter(post => filterByAuthor(post, filter)).filter(post => ((post.title).toLowerCase()).includes((filter.keyword).toLowerCase()));

    const removeAuthor = () => {
        dispatch(allPostByAuthor(''));
    }
    const removeCategory = () => {
        dispatch(allPostByCategory(''));
    }

    return (
        <div>
            <section
                className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8"
            >
                <div className="absolute inset-0">
                    <div className="bg-white h-1/3 sm:h-2/3"></div>
                </div>
                <div className="relative max-w-7xl mx-auto">
                    <div className="text-center">
                        {filter.keyword ? <h2
                            className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
                        >
                            Searching Results For : {filter.keyword}
                        </h2> :
                            <h2
                                className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
                            >
                                ALL BLOGS ARE HERE
                            </h2>
                        }
                        <p
                            className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4"
                        >
                            Lorem ipsum dolor sit amet consectetur, adipisicing
                            elit. Ipsa libero labore natus atque, ducimus sed.
                        </p>
                    </div>

                    {
                        (filter.category === '' && filter.author === '') ||
                        <div className='flex justify-between items-center border-solid border-2 bg-gray-200 rounded-full'>
                            <div className='flex font-bold pl-2 flex-col md:flex-row' >
                                <div onClick={() => removeAuthor("")}>
                                    {filter.author === '' ? <span></span> : <span className='my-2'>Author : <button className='bg-white pl-2 rounded-full'>{filter.author} <span className='px-2 m-2 rounded-full border-solid border-2 bg-red-400 text-white'>X</span> </button></span>}
                                </div>
                                <div onClick={() => removeCategory("")}>
                                    {filter.category === '' ? <span></span> : <span className='my-2'>Category : <button className='bg-white pl-2 rounded-full'>{filter.category} <span className='px-2 m-2 rounded-full border-solid border-2 bg-red-400 text-white'>X</span> </button></span>}
                                </div>
                            </div>

                            <div className='flex justify-end'>
                                <button className=' rounded-full bg-black text-white px-2 py-1'
                                    onClick={() => {
                                        removeAuthor("");
                                        removeCategory("");
                                    }}
                                >
                                    Clear Filter
                                </button>
                            </div>
                        </div>
                    }
                    {/* <!-- card grid  --> */}
                    <div
                        className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none"
                    >
                        {/* <!-- single card  --> */}
                        {
                            posts.map(post => (
                                <SingleBlog key={post.id} post={post} />
                            ))

                        }
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AllBlogs;